export default __webpack_public_path__ + "static/linkedin-49691bb67f0ddd3b5f206b2b1995e6c8.svg";